import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import './assets/style/variables.module.scss';
import '@brainhubeu/react-carousel/lib/style.css';

export const store = configureStore();

export const state = store.getState();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
